import AbstractPriceModel from 'coreClasses/product/AbstractPriceModel';
import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import ProductItemModel from './ProductItemModel';

/**
 * Represents ProductItemPriceModel
 */
class ProductItemPriceModel extends AbstractPriceModel {
	/**
	 * @constructor
	 * @param {ProductItemModel} productItemModel - the product item model
	 */
	constructor(private productItemModel: ProductItemModel) {
		super(productItemModel.getProductModel() as ProductModel | VariantModel);

		this.productItemModel = productItemModel;
	}

	/**
	 * Returns the minimal price after discounts
	 * @return {Number} the minimal price
	 */
	getMinPrice() {
		return {
			currency: this.productItemModel.getCurrency(),
			value: this.productItemModel?.getPriceAfterItemDiscount(),
			pricebook: 'default',
		};
	}

	/**
	 * Returns the standard price
	 * @return {Number}
	 */
	getListPrice() {
		const listPrice = super.getList();

		return this.productItemModel?.getPrice() || (listPrice?.value * this.productItemModel.getQuantity());
	}

	/**
	 * Returns the sales price
	 * @return {Object}
	 */
	getSales() {
		return {
			currency: this.productItemModel.getCurrency(),
			value: this.getMinPrice().value,
		};
	}

	/**
	 * Returns the list price
	 * @return {Object}
	 */
	getList() {
		const minPrice = this.getMinPrice();
		const listPrice = this.getListPrice();

		if (minPrice.value !== listPrice && !this.productItemModel.isCustomizable()) {
			return {
				currency: this.productItemModel.getCurrency(),
				value: listPrice,
			};
		} else {
			return null;
		}
	}
}

export default ProductItemPriceModel;
